<template>
	<v-modal>
		<template v-slot:header>
			<h1>Conveyancing quote</h1>
		</template>
		<ConveyancingQuoteBreakdownTabs :display-vat="displayVat" :quote="quote"/>
		<template v-slot:footer>
			<ul class="actions action--right">
				<li v-if="$can('update', quote)">
					<button
						class="button button--primary"
						@click.prevent="$vmodal.routeTo({name: 'quotes.edit', params: {quote: quote.id}})">Edit
					</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import ConveyancingQuoteBreakdownTabbed from "./ConveyancingQuoteBreakdownTabbed";
import ConveyancingQuoteBreakdownTabs from "./ConveyancingQuoteBreakdownTabs.vue";

export default {
	components: {
		ConveyancingQuoteBreakdownTabs,
		ConveyancingQuoteBreakdownTabbed,
	},

	props: {
		quote: {
			required: true,
			type: Object,
		},
		displayVat: {
			required: false,
			type: Boolean,
			default() {
				return true;
			},
		},
	},

	methods: {
		feeName(feeIndex) {
			return feeIndex.toLowerCase()
				.replace("fee_", "")
				.replace("disbursement_", "")
				.split("_")
				.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
				.join(" ");
		},
	},
};
</script>
